import { useState } from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { colorPalette, fontPalette } from '../../../static/styles/global'

interface tabSwitchProps {
  tabOneLabel?: string
  tabTwoLabel?: string
}

const TabSwitch = ({
  tabOneLabel = 'Available',
  tabTwoLabel = 'Not Available'
}: tabSwitchProps): JSX.Element => {
  const [tabOneState, setTabOneState] = useState(true)
  const [tabTwoState, setTabTwoState] = useState(false)

  const handleToggleSwicth = (tab: string) => {
    if (tab === 'two') {
      setTabOneState(false)
      setTabTwoState(true)
    } else {
      setTabOneState(true)
      setTabTwoState(false)
    }
  }

  return (
    <View style={[styles.tabs]}>
      <TouchableOpacity
        onPress={() => handleToggleSwicth('one')}
        style={[styles.tab, styles.firstTab, tabOneState && styles.tabActive]}
      >
        <Text style={[styles.tabText, tabOneState && styles.tabActiveText]}>
          {tabOneLabel}
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => handleToggleSwicth('two')}
        style={[styles.tab, styles.lastTab, tabTwoState && styles.tabActive]}
      >
        <Text style={[styles.tabText, tabTwoState && styles.tabActiveText]}>
          {tabTwoLabel}
        </Text>
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  tabs: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: colorPalette.secondary,
    borderRadius: 8
  },
  tab: {
    flex: 1,
    paddingVertical: 10
  },
  firstTab: {
    borderTopLeftRadius: 7,
    borderBottomLeftRadius: 7
  },
  lastTab: {
    borderTopRightRadius: 7,
    borderBottomRightRadius: 7
  },
  tabActive: {
    backgroundColor: colorPalette.secondary
  },
  tabText: {
    fontFamily: fontPalette.primaryRegular,
    textAlign: 'center',
    color: colorPalette.secondary
  },
  tabActiveText: {
    color: colorPalette.white
  }
})

export default TabSwitch
